export default {
  monthNames: {
    short: {
      january: 'ENE',
      february: 'FEB',
      march: 'MAR',
      april: 'ABR',
      may: 'MAY',
      june: 'JUN',
      july: 'JUL',
      august: 'AGO',
      september: 'SEP',
      october: 'OCT',
      november: 'NOV',
      december: 'DIC',
    },
    long: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
    },
  },
  pageNotFound: {
    warning: 'Página no encontrada :(',
    backToPortal: 'Volver al portal',
  },
  login: {
    email: {
      label: 'Correo Electrónico de Usuario',
      placeholder: 'Correo Electrónico',
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Contraseña',
      forgot: '¿Olvidaste tu contraseña?',
      show: 'Mostrar Contraseña',
    },
    recoverPassword: {
      greetings: '¡Hola',
      label:
        'Ingressa tu correo electrónico a continuación.Te enviaremos un enlace para restablecer su contraseña.',
      resetPasswordLabel: 'Configure una nueva contraseña',
      errorMessage: 'Correo electrónico no encontrado o bloqueado.',
      successMessage:
        '¡Listo! El proceso de reconfiguracíon de contraseña fue enviado para su correo electrónico.',
      renewMessage:
        'Ingressa sus datos en el formulario para renovar su contraseña.',
      renewError: 'Error al renovar su contraseña, vuelva a intentarlo.',
      smallPasswordError:
        'Prueba con una contraseña que tenga al menos 8 caracteres.',
      wrongPasswordError: 'Las contraseñas no coinciden',
      renewSuccess: 'Tu contraseña ha sido actualizada.',
      button: 'restablecer Contraseña',
      backToLogin: 'Volver al login',
      newPassword: 'Nueva Contraseña',
      newPasswordConfirm: 'Confirmar nueva contraseña',
    },
    keepMeLogged: {
      label: 'Recuérdame',
    },
    signInButton: {
      label: 'INICIAR SESIÓN',
    },
    welcome: '¡Bienvenido!',
    signin: 'Inicia sesión en tu cuenta.',
    error: 'Error al acceder a tu cuenta, verifique los datos ingresados.',
    errorNotFound: 'Contactar con soporte',
    renew: 'Renueva y la dirección cambia a proyecto',
  },
  index: {
    content: {
      introduction: 'Introducción',
      showIntroduction: 'MOSTRAR INTRODUCCIÓN',
      hideIntroduction: 'OCULTAR INTRODUCCIÓN',
      minutes: 'Minutos',
      classes: 'Clases',
      showClasses: 'MOSTRAR CLASES',
      hideClasses: 'OCULTAR CLASES',
      dateOpenModule: 'ESTE MÓDULO ESTARÁ DISPONIBLE EN',
      openSubmodule: 'ABRIR SUBMÓDULO',
      closeSubmodule: 'CERRAR SUBMÓDULO',
      completed: 'COMPLETO',
      concluded: 'CONCLUIDO',
      completedAt: 'CONCLUIDO EN',
      beginClass: 'EMPEZAR CLASSE',
      emptyMessage:
        '¡En este momento no hay ninguno contenido para este módulo!.',
      progressiveUnavailable: 'COMPLETE LAS CLASES ANTERIORES',
    },
    header: {
      startCourse: 'EMPEZAR CURSO',
      resumeCourse: 'CONTINUAR CURSO',
      notes: {
        button: 'MIS ANOTACIONES',
        modal: {
          title: 'Mis anotaciones',
          download: 'DESCARGAR NOTAS',
        },
      },
      faq: {
        button: 'PREGUNTAS FRECUENTES',
        modal: {
          title: 'Preguntas frecuentes',
        },
      },
      search: {
        title: '¿Qué estás buscando?',
        popularTags: 'TAGS MÁS POPULARES',
        resultCount:
          '{resultCount} resultados encontrados con el filtro "{searchFilter}"',
        seeMore: 'Vea Más',
      },
      nextClass: {
        title: 'SU PRÓXIMA CLASE',
      },
      emailSupport: 'suporte@ignicaodigital.com.br',
      doubts: '¿Tiene dudas o problemas? Hable con nuestro soporte:',
    },
    sidebar: {
      completedModules: 'MÓDULOS COMPLETADOS',
    },
  },
  general: {
    labels: {
      loading: 'Cargando...',
      uploading: 'Haciendo Upload',
    },
    actions: {
      search: 'Buscar',
      communitySearch: 'Buscar en la comunidad',
      clearSearch: 'Borrar búsqueda',
      start: 'EMPEZAR',
      cancel: 'Cancelar',
      orderBy: 'Ordenar por',
      updateChanges: 'GUARDAR CAMBIOS',
      access: 'Acceso',
      edit: 'Editar',
      remove: 'Eliminar',
      save: 'Guardar',
      back: 'Volver',
      mute: 'Silenciar',
      unmute: 'Sacar {user} del modo silencioso',
      saveChanges: 'Guardar Cambios',
      filter: 'Filtro',
    },
    messages: {
      noRecordFound: 'No se encontraron registros',
    },
  },
  logout: {
    label: 'Salir',
  },
  class: {
    details: {
      tags: 'Tags',
      nav: {
        description: 'DESCRIPCIÓN',
        comments: 'COMENTARIOS',
        extraContent: 'EXTRA',
        notes: 'ANOTACIONES',
      },
      comments: {
        title: 'Comentarios',
        reply: 'Contestar',
        post: 'Publicar',
        remove: 'Quitar',
        pending: 'PENDIENTE DE MODERACIÓN',
        highlight: 'Resaltar',
        highlighted: 'Respuesta Resaltada',
        removeHighlight: 'Eliminar Resaltado',
      },
      downloads: {
        download: 'Descargar',
        visualize: 'Visualizar',
      },
    },
    progress: {
      completeClass: 'COMPLETAR CLASE',
      moveToNext: 'E IR PARA LA PRÓXIMA',
      moveToPrev: 'VOLVER A LA CLASE ANTERIOR',
      seeIndex: 'VER ÍNDICE DE CLASES',
    },
    sidebar: {
      module: 'Módulo',
      noContent: 'En este momento no hay contenido',
    },
  },
  profile: {
    loadingImage: 'Cargando Imagen...',
    imageAlt: 'Imagen de Perfil',
    changeImage: 'Cambiar Imagen',
    fileSizeError: 'El tamaño de la imagen es demasiado grande',
    errorLoadingImage: 'Error al cargar la imagen',
    menuTitle: 'MI PERFIL Y CONTRASEÑA',
    name: 'Nombre',
    password: 'Contraseña',
    retypePassword: 'Confirmar Contraseña',
    passwords: {
      alertError:
        'Error al cambiar la contrasenha, verifique dados ingresados.',
      alertSuccess: 'Contraseña actualizada correctamente.',
      notMatching: 'Las contraseñas no coinciden.',
    },
    updatedMessage: 'Perfil actualizado con éxito',
    updateError: 'Error al actualizar el perfil, intenta de nuevo más tarde',
  },
  cookie: {
    disabled: 'Cookies no permitidas',
    enable:
      'Las cookies deben estar habilitadas en tu navegador web, se las permita y actualice la página.',
  },
  banner: {
    defaultText: 'Editar su banner en la configuración',
    defaultButtonText: 'acción del botón',
  },
  community: {
    notFound: 'Comunidad no encontrada',
    title: 'Comunidad',
    night_mode: 'Modo nocturno',
    discussion: 'Discusión',
    labels: {
      like: 'Me gusta',
      liked: 'Me gustó',
      likes: 'Me gusta',
      updatedAt: 'Actualizado a',
    },
    users: {
      title: 'Usuarios',
      members: 'Miembros',
      notMuted: 'No silenciado',
      profile: {
        title: 'Perfil',
        view: 'Ver Perfil',
        header: 'Perfil del Usuario',
        statistics: 'Estadísticas',
        badges: 'Medallas',
        notifications: 'Notificaciones de Email',
        createdPosts: 'Posts creados',
        createdComments: 'Comentarios creados',
        likes: 'Gustos',
        postsLikes: 'Curtidos de Posts',
        commentsLikes: 'Curtidos de Comentarios',
      },
      mailSettings: {
        info: 'Me avisa cuando...',
        postComment: 'Alguien comentar en mi post',
        postLike: 'Alguien gusta de mi post',
        followedPostComment: 'Alguien comentar en un post que estoy siguiendo',
        followedPostLike: 'Alguien gusta de un post que estoy siguiendo',
        commentLike: 'Alguien que gusta de un comentario que escribí',
        reply: 'Alguien responder un comentario que escribí',
        postMention: 'Alguien me menciona en un post',
        commentMention: 'Alguien me menciona en un comentario',
        badge: 'Yo recibo una medalla',
        postApproved: 'Mi post es aprobado',
        commentApproved: 'Mi comentario es aprobado',
      },
    },
    list: {
      selectOne: 'Seleccione la comunidad deseada',
    },
    events: {
      openDate: 'Fecha de Inicio',
      closeDate: 'Fecha de Finalización',
    },
    posts: {
      viewPost: 'Ver {kind}',
      title: 'Posts',
      searchLabel: 'Buscar miembro por nombre o e-mail',
      actions: {
        create: 'Crear un Nuevo Post',
        start: 'Escribir nuevo post',
        comment: '¿En que estas pensando?',
      },
      removed: 'Post eliminado',
      follow: 'Seguir post',
      unfollow: 'No seguir post',
      writeTitle: 'Escriba un título',
      createBookmark: 'Agregar a los favoritos',
      removeBookmark: 'Quitar de los favoritos',
      kind: {
        post: 'Post',
        event: 'Acontecimiento',
      },
      toTop: 'En la parte superior',
      toAside: 'Ao Lado',
      pinTitle: 'Arreglar',
      pin: {
        top: 'Pin en la parte superior',
        aside: 'Pin ao Lado',
      },
      unpin: {
        top: 'Desanclar desde arriba',
        aside: 'Desenrosque lateral',
      },
      messages: {
        follow: {
          success: 'Post seguido con éxito!',
          error: 'No se pudo seguir el post.',
        },
        unfollow: {
          success: 'Post dejado de seguir con éxito!',
          error: 'No se pudo dejar de seguir el post.',
        },
        createBookmark: {
          success: 'Post agregado a los favoritos con éxito!',
          error: 'No se pudo agregar el post a los favoritos.',
        },
        removeBookmark: {
          success: 'Post quitado de los favoritos con éxito!',
          error: 'No se pudo quitar el post de los favoritos.',
        },
        create: {
          error: 'Rellene el título, el tag y el contenido',
        },
      },
    },
    badges: {
      title: 'Medallas',
      assign: 'Dar medallas',
      select: 'Seleccione una o más medallas',
      selected:
        'Ninguna medalla seleccionada | 1 medalla seleccionada | {count} medallas seleccionadas',
      no_badges_registered: 'No hay medallas catastradas',
    },
    comments: {
      loadAll: 'Carregar todos los comentarios',
      title: 'No hay comentarios | 1 comentario | {count} comentarios',
      label: 'Comentarios',
      actions: {
        create: 'Comentar',
        remove: 'Quitar Comentario',
        update: 'Actualizar Comentario',
        comment: 'Escribir un comentario',
      },
      warnings: {
        remove: 'Está seguro de que desea eliminar este comentario',
      },
      replies: {
        view: '1 respuesta | {count} respuestas',
        viewMore: 'Ver más respuestas',
      },
    },
    useTerms: {
      title: 'Terminos de Uso',
      accept: 'Aceptar Terminos de Uso',
      decline: 'Rechazo los terminos',
      agreed: 'Acepto los terminos de uso de la comunidad',
      seeTerms: 'Ver los terminos de uso de la comunidad',
    },
    moderation: {
      title: 'Moderación',
      postStatus: 'Estado del post',
      status: {
        pending: 'Pendiente',
        visible: 'Visible',
        locked: 'Bloqueado',
        muted: 'En silencio',
      },
      filters: {
        apply: 'Aplicar',
        pending: 'Pendientes',
        locked: 'Bloqueados',
        muted: 'En silencio',
        posts: 'Filtrar posts',
        comments: 'Filtrar comentarios',
      },
    },
    tags: {
      popular: 'Etiquetas más populares',
      add: 'Haz clic y / o escribe para añadir etiquetas',
      showAll: 'Muestra todo',
      showLess: 'Muestra menos',
      selectLabel: 'Haz clic o presione enter para añadir',
      deselectLabel: 'Haz clic o presione enter para eliminar',
      selectedLabel: 'Agregada',
      emptyListLabel: 'la lista esta vacía',
      all: 'Todas las etiquetas',
    },
    rules: {
      title: 'Normas',
      sidebarLabel: 'Normas de la comunidad',
    },
    orders: {
      resultCount: 'Mostrando {resultCount} de {totalResult} miembros',
      apply: 'Aplicar',
      label: 'ORDENAR MIEMBROS POR',
      posts: 'Más mensajes creados',
      postLikes: 'Más curtidos recibidos en los posts',
      comments: 'Más comentarios',
      commentLikes: 'Más curtidos recibidos en comentarios',
      badges: 'Mayor cantidad de medallas',
    },
    notifications: {
      title: 'Notificaciones',
      timeFrom: 'Hace {time}',
      seeAll: 'Ver todo',
      markAsRead: 'Marcar como leído',
      markAsUnread: 'Marcar como no leído',
      markAllAsRead: 'Marcar todas como leídas',
    },
    bookmark: {
      title: 'Favoritos',
    },
    medias: {
      video: {
        urlPlaceholder: 'Youtube o Vimeo URL',
        postTitle: 'Añadir vídeo al post',
        commentTitle: 'Añadir vídeo al comentario',
        add: 'Añadir al post',
      },
    },
  },
  pagination: {
    first: 'Primera',
    last: 'Última',
    next: 'Seguiente',
    previous: 'Anterior',
  },
  emojis: {
    search: 'Buscar',
    notfound: 'No hay Emoji encontrado',
    categories: {
      search: 'Resultados',
      recent: 'Reciente',
      people: 'Gente & Smileys',
      nature: 'Animales & Naturaleza',
      foods: 'Comida y Bebida',
      activity: 'Actividad',
      places: 'Viajes y Lugares',
      objects: 'Objetos',
      symbols: 'Simbolos',
      flags: 'Banderas',
      custom: 'Personalizado',
    },
  },
  textEditor: {
    toolbar: {
      fontSize: 'Tamaño de Fuente',
      fontType: 'Tipo de Fuente',
      align: 'Alinear texto',
      headerType: 'Tipo de Encabezado',
      clean: 'Limpiar Texto',
      textColor: 'Color de Texto',
      textBackground: 'Color de fondo de Texto',
      bold: 'Negrito',
      italic: 'Itálico',
      underlined: 'Subrayado',
      strike: 'Rayado',
      unorderedList: 'Lista no Ordenada',
      orderedList: 'Lista Ordenada',
      link: 'Insertar Link',
      image: 'Insertar Imagen',
      subscript: 'Subscript',
      superscript: 'Superscript',
      blockquote: 'Cita',
      increaseIndent: 'Aumentar la Indentación',
      decreaseIndent: 'Disminuir la Indentación',
    },
    fontSize: {
      small: 'small',
      medium: 'medium',
      large: 'large',
      huge: 'huge',
    },
    font: {
      sansSerif: 'Sans Serif',
      serif: 'Serif',
      monospace: 'Monospace',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/es_ES.js